(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-form"] && !Shopify.designMode) return;
  try {
    jQuery(document).ready(() => {
      const q = jQuery('.close_search__button').parent().find('[name="q"]');
      const close = jQuery('.close_search__button');
      const result = jQuery('.search-matrix');
      if (q.val().trim().length >= 2) {
        jQuery('.close_search__button').removeClass('hidden');
      }
      close.on('click', function() {
        if (result.length) {
          result.remove();
          jQuery(this).remove();
        } else {
          jQuery('.close_search__button').addClass('hidden');
        }
        q.val('');
        window.history.pushState({ page: '' }, '', '/search');
      });
      q.on('keyup', function() {
        if (jQuery(this).val().trim().length >= 2) {
          jQuery('.close_search__button').removeClass('hidden');
        } else {
          jQuery('.close_search__button').addClass('hidden');
        }
      });
    });
  } catch(e) { console.error(e); }
})();

})();
